import { genUuid } from "@screencloud/uuid";
import { get, set } from "./storeManager";

let sessionId: string | undefined = undefined;

export const VIEWER_ID_STORAGE_KEY = "embed-viewer-id";
export const SESSION_ID_STORAGE_KEY = "session-id";

/**
 * Viewer id is stored per browser (persisted long term)
 */
export function clientEmbedViewerId(): string {
    let viewerId = get(VIEWER_ID_STORAGE_KEY);

    if (!viewerId) {
        viewerId = genUuid();
        set(VIEWER_ID_STORAGE_KEY, viewerId);
    }

    return viewerId;
}

/**
 * Session id is stored per app launch (gone when the tab is closed)
 */
export function clientSessionId(): string {
    if (sessionId === undefined) {
        sessionId = genUuid();
    }

    return sessionId;
}
